import type React from 'react'
import { twMerge } from 'tailwind-merge'

interface IWideButtonProps {
  handleClick: () => void
  buttonText: string | React.JSX.Element
  className?: string
  isDisabled?: boolean
}

const WideButton = ({ handleClick, buttonText, className, isDisabled = false }: IWideButtonProps) => {
  return (
    <button
      onClick={handleClick}
      className={twMerge(
        'w-full bg-white hover:bg-amber-50 text-amber-900 font-bold py-4 rounded-2xl shadow-lg transition-all duration-200 hover:scale-105 active:scale-95 border border-amber-200',
        className
      )}
      disabled={isDisabled}
    >
      {buttonText}
    </button>
  )
}

export default WideButton
